import * as React from "react"
import Check from "@kiwicom/orbit-components/lib/icons/Check"
import Close from "@kiwicom/orbit-components/lib/icons/Close"

const fieldValidation = ({
  ok = false,
  error = false,
}: {
  ok?: boolean
  error?: boolean
}): {
  className: string
  icon: React.ReactNode
} => {
  if (ok) {
    return {
      className: "_ok",
      icon: <Check ariaHidden size="small" className="fieldValidation-icon" />,
    }
  }
  if (error) {
    return {
      className: "_error",
      icon: <Close ariaHidden size="small" className="fieldValidation-icon" />,
    }
  }
  return {
    className: "",
    icon: null,
  }
}

export default fieldValidation
